
import {
    GET_PROSPECT_REFUND_REASONS,
    GET_PROSPECT_REFUND_REASONS_SUCCESS,
    GET_PROSPECT_REFUND_REASONS_ERROR,
} from "./actionTypes";

// getLeadRefundReasons
export const getProspectRefundReasons = payload => {
    return {
        type: GET_PROSPECT_REFUND_REASONS,
        payload: payload,
    }
}

// getLeadRefundReasonsSuccess
export const getProspectRefundReasonsSuccess = leadRefundReasons => {
    return {
        type: GET_PROSPECT_REFUND_REASONS_SUCCESS,
        payload: leadRefundReasons,
    }
}

// getLeadRefundReasonsError
export const getProspectRefundReasonsError = error => {
    return {
        type: GET_PROSPECT_REFUND_REASONS_ERROR,
        payload: error,
    }
}

